@let options = popoverOptions();
<div
  id="{{ options.popoverID }}"
  (click)="$event.stopPropagation()"
  class="popover-container border-rounded"
  [class.rounded-large]="roundedCorners"
  #popoverContent
  [ngStyle]="{
    top: (popoverPositionProperties$ | async).top,
    left: (popoverPositionProperties$ | async).left,
    zIndex: (popoverPositionProperties$ | async).zIndex,
  }"
  [ngClass]="{
    fixed: isFixedPosition,
    absolute: !isFixedPosition,
    'elevation-level-1': options.shadow,
  }"
  [class.fullscreen]="isFullscreen$ | async"
  fcomTrapFocus
>
  @if (showArrowCaret) {
    <div class="arrow-container" [ngClass]="arrowPositionClass" [style.left.px]="arrowPosition$ | async">
      <div class="arrow"></div>
    </div>
  }
  <div
    class="white-bg surface-primary grow fill elevation-level-1 flex flex--column flex--wrap flex--align-start align-left border nordic-blue-25-border border-primary"
    [class.rounded-large]="roundedCorners"
    [class.ps-medium]="hasPadding"
    [class.popover-border]="showLeftBorder"
    [ngStyle]="{
      width: (popoverPositionProperties$ | async).width,
    }"
    data-testid="popover-content-wrapper"
  >
    <div
      class="flex fill grow"
      [ngClass]="{
        'flex--align-start': !options.fullWidthContent,
        'flex--align-end': options.fullWidthContent,
        'flex--column-reverse': options.fullWidthContent,
      }"
    >
      <div
        class="flex flex--column flex-1 fill"
        aria-live="polite"
        [ngStyle]="{
          maxHeight: (popoverPositionProperties$ | async)?.['max-height'],
        }"
      >
        <ng-container *ngTemplateOutlet="content" />
      </div>
      @if (options.showCloseButton) {
        <button
          class="popover-close absolute nordic-blue-900-text text-icon-primary"
          type="button"
          [attr.aria-label]="ariaCloseText"
          (click)="closePopover()"
          #closeButton
          data-testid="popover-close-button"
        >
          <fcom-icon class="icon-small" [name]="SvgLibraryIcon.CLOSE_DELETE" />
        </button>
      }
    </div>

    @if (closeText) {
      <button type="button" class="font-body-1 mr-xxsmall-t font-body-medium" (click)="closePopover()">
        {{ closeText }}
      </button>
    }
  </div>
</div>
